import React, { createContext, useState, useContext } from "react";

// Crea il Context per la ricerca avanzata
const AdvSearchCtx = createContext();

// Crea il Provider per il Context
export const AdvSearchProvider = ({ children }) => {
  const [centerCoords, setCenterCoords] = useState({
    lat: 44.801485,
    lng: 10.328,
    radius: 20,
  });
  const [params, setParams] = useState({});

  const value = {
    centerCoords,
    params,
    setParams,
    setCenterCoords,
  };

  return (
    <AdvSearchCtx.Provider value={value}>{children}</AdvSearchCtx.Provider>
  );
};

// Crea un hook personalizzato per utilizzare il context
export const useAdvSearch = () => {
  const context = useContext(AdvSearchCtx);
  if (!context) {
    throw new Error(
      "useAdvSearch deve essere utilizzato all'interno di un AdvSearchProvider",
    );
  }
  return context;
};
